/**
 * Naming the warehouse an ASN/PO is going to.
 *
 * `asn.warehouse` is populated (see control-tower's asn.hooks) with the whole
 * warehouse document, which in turn nests its WMS `provider`. Those are two
 * very different things and picking the wrong one is silent:
 *
 *   provider  — the WMS INTEGRATION ("rl"). Every location of a client
 *               deliberately shares one provider; that sharing is what lets a
 *               client run many warehouses through a single WMS connection
 *               (see pipe17-provider/provider/location-map.js). Rendering it as
 *               "the warehouse" therefore shows the SAME word on every record
 *               no matter where the goods are actually going.
 *   warehouse — the physical site. `name` is its label and `warehouse_code` is
 *               the only one of the two the model requires, so an unnamed
 *               warehouse still resolves to something an operator recognises.
 *
 * The provider name is kept as a last resort rather than dropped: a record
 * whose warehouse predates `warehouse_code` is better identified by its
 * integration than by a blank.
 */
export const warehouseLabel = (warehouse) =>
  warehouse?.name ||
  warehouse?.warehouse_code ||
  warehouse?.provider?.name ||
  "";

export default warehouseLabel;
